// The browser installation an event comes from: a random id kept in this
// browser profile (no fingerprint; a new profile, private window or cleared
// storage gets a new one) plus small, unverified browser/OS/app metadata.
import { DeviceInfo, randomId } from './events';

const INSTALLATION_KEY = 'securityActivity.installationId';

const APP_VERSION: string = (() => {
  try {
    return String(require('../../../package.json').version);
  } catch {
    return 'unknown';
  }
})();

// Without usable storage the installation is this page; it keeps one id.
let pageInstallation: string | null = null;

export const installationId = (storage: () => Storage = () => window.localStorage) => {
  try {
    const store = storage();
    const stored = store.getItem(INSTALLATION_KEY);
    if (stored && /^[a-f0-9]{32}$/.test(stored)) return stored;
    const created = pageInstallation ?? randomId();
    pageInstallation = created;
    store.setItem(INSTALLATION_KEY, created);
    return created;
  } catch {
    pageInstallation = pageInstallation ?? randomId();
    return pageInstallation;
  }
};

const BROWSERS: [RegExp, string][] = [
  [/Edg\/(\d+)/, 'Edge'],
  [/SamsungBrowser\/(\d+)/, 'Samsung Internet'],
  [/OPR\/(\d+)/, 'Opera'],
  [/Firefox\/(\d+)/, 'Firefox'],
  [/CriOS\/(\d+)/, 'Chrome'],
  [/Chrome\/(\d+)/, 'Chrome'],
  [/Version\/(\d+).*Safari/, 'Safari'],
];

const browserOf = (ua: string) => {
  for (const [pattern, name] of BROWSERS) {
    const match = pattern.exec(ua);
    if (match) return `${name} ${match[1]}`;
  }
  return 'Unbekannt';
};

const osOf = (ua: string, touchPoints: number) => {
  if (/iPad/.test(ua) || (/Macintosh/.test(ua) && touchPoints > 1)) return 'iPadOS';
  if (/iPhone|iPod/.test(ua)) return 'iOS';
  if (/Android/.test(ua)) return 'Android';
  if (/Windows/.test(ua)) return 'Windows';
  if (/Mac OS X|Macintosh/.test(ua)) return 'macOS';
  if (/CrOS/.test(ua)) return 'ChromeOS';
  if (/Linux/.test(ua)) return 'Linux';
  return 'Unbekannt';
};

export const deviceInfo = (nav: Navigator = window.navigator): DeviceInfo => ({
  browser: browserOf(nav.userAgent ?? ''),
  os: osOf(nav.userAgent ?? '', nav.maxTouchPoints ?? 0),
  appVersion: APP_VERSION.slice(0, 40),
});
